module.exports = __webpack_public_path__ + "img/shinjuku.e8ea8a70.jpg";